/**
 * @generated SignedSource<<2efe6dc30755b3fccfa445b76e752278>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type scmpWidgetConfigAppConfigQuery$variables = Record<PropertyKey, never>;
export type scmpWidgetConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type scmpWidgetConfigAppConfigQuery = {
  response: scmpWidgetConfigAppConfigQuery$data;
  variables: scmpWidgetConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_pwa_settings"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "scmpWidgetConfigAppConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "scmpWidgetConfigAppConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4714d5c414e4c2779a4b8268f559ac79",
    "id": null,
    "metadata": {},
    "name": "scmpWidgetConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query scmpWidgetConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "1db067a0c494ece0d54705cc3faf1de8";

export default node;
